import { AuthenticationService, JWTToken } from '@philips-emr/tws-core/lib/services';

import TokenConstants from '../constants/token-constants';

interface AllowedFuncion {
  extFinMensalidade: boolean;
  extAcessoAutorizacao: boolean;
  extBenefAltCadastral: boolean;
}

interface ClaimValue {
  cdPessoaFisica: string;
  nrSeqBeneficiario: string;
}

export class TokenUtils {

  private static getToken(): JWTToken {
    const token = AuthenticationService.getJWTToken();
    if (!token) {
      throw 'token-utils: [JWTToken] is not defined';
    }
    return token;
  }

  private static getClaim(name: TokenConstants): string {
    return this.getToken().claims[name] as string;
  }

  static getValues(): ClaimValue {
    return {
      cdPessoaFisica: this.getClaim(TokenConstants.CD_PESSOA_FISICA),
      nrSeqBeneficiario: this.getClaim(TokenConstants.NR_SEQ_BENEFICIARIO),
    };
  }

  static getAllowedFuncion(): AllowedFuncion {
    return {
      extFinMensalidade: this.getClaim(TokenConstants.FIN_MENSALIDADE) === 'S',
      extAcessoAutorizacao: this.getClaim(TokenConstants.ACESSO_AUTORIZACAO) === 'S',
      extBenefAltCadastral: this.getClaim(TokenConstants.ALTERACAO_CADASTRAL) === 'S',
    };
  }

}
